import moment from 'moment-timezone';

export function checkIsValidSchedule(schedule) {
    return (
        typeof schedule.hour === 'number' && typeof schedule.minute === 'number'
    );
}

export function getCurrentTimezone() {
    return moment.tz.guess() ?? 'UTC';
}

export function checkHasDuplicateSchedules(schedules) {
    const seen = new Set();

    if (!schedules.length) {
        return false;
    }

    return schedules.some((schedule) => {
        if (!checkIsValidSchedule(schedule)) {
            return false;
        }

        const key = `${schedule.hour}:${schedule.minute}`;

        if (seen.has(key)) {
            return true;
        }

        seen.add(key);
        return false;
    });
}
